import React from 'react';
export class AddToBrandFavorites extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const displayMyFavorites = this.props.passedAppFunctions.wasParms.myFavorites;
    const hasPersonalizationCategoryid = this.props.passedFunctions.getPersonalizationCategoryId();
    //the product must live in a category that we track for personalization
    //and that we have a tab for on the my favorite brands manage page
    //so if we dont have a personalizationCategoryId do not show the button

    return (
      <>
        {hasPersonalizationCategoryid &&
          displayMyFavorites == 'true' &&
          !this.props.passedAppFunctions.isInternational() &&
          (typeof window == 'undefined' || (window.Modernizr && Modernizr.localstorage)) && (
            <button
              className='btn btn-tertiary'
              role='button'
              type='button'
              id='add-to-favorite'
              data-attritem={this.props.dataAttrItem}
              onClick={async () => {
                this.props.passedOnClick
                  ? this.props.passedOnClick()
                  : await this.props.passedFunctions.ajaxAddToBrandFavorites();
              }}
              {...this.props.passedDataIds}
            >
              {this.props.passedFunctions.thisBrandInMyFavorites() ? (
                <>
                  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 50.77 48.69' aria-hidden='true'>
                    <title>star-full</title>
                    <g data-name='Layer 2'>
                      <g data-name='Layer 1'>
                        <path d='M50.75,19a.49.49,0,0,0-.47-.34H32L25.85.33a.49.49,0,0,0-.93,0L18.81,18.67H.49a.49.49,0,0,0-.28.89L15.27,30.14,9.57,48.06a.49.49,0,0,0,.75.54l15.06-11,15.06,11a.49.49,0,0,0,.75-.54L35.5,30.14,50.56,19.56A.49.49,0,0,0,50.75,19Z' />
                      </g>
                    </g>
                  </svg>
                  Remove Preferred Brand
                </>
              ) : (
                <>
                  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 52.77 50.69' aria-hidden='true'>
                    <title>star-outline</title>
                    <g data-name='Layer 2'>
                      <g data-name='Layer 1'>
                        <path d='M11,50.69a1.49,1.49,0,0,1-1.42-1.94l5.48-17.21L.63,21.38a1.49,1.49,0,0,1,.86-2.71h17.6L25,1A1.49,1.49,0,0,1,27.8,1l5.89,17.65h17.6a1.49,1.49,0,0,1,.85,2.71L37.68,31.54l5.48,17.22a1.49,1.49,0,0,1-.55,1.66,1.52,1.52,0,0,1-1.75,0L26.39,39.85,11.91,50.41A1.49,1.49,0,0,1,11,50.69Zm.49-1.33h0ZM42,48.79h0ZM26.39,37.61a1,1,0,0,1,.59.19l13.8,10.07L35.55,31.45a1,1,0,0,1,.38-1.12l13.74-9.65H33A1,1,0,0,1,32,20L26.39,3.11,20.76,20a1,1,0,0,1-.95.68H3.11l13.74,9.65a1,1,0,0,1,.38,1.12L12,47.87,25.8,37.8A1,1,0,0,1,26.39,37.61ZM51,19.74h0Zm-49.21,0h0Z' />
                      </g>
                    </g>
                  </svg>
                  Add To Preferred Brands
                </>
              )}
            </button>
          )}
      </>
    );
  }
}

export default AddToBrandFavorites;
